export default __webpack_public_path__ + "static/media/homeBoxing.d3ccee9d.png";